// utils/logger.ts
const isDev = process.env.NODE_ENV === 'development';

export const logger = {
  error: (message: string, error?: any) => {
    if (isDev) {
      console.error(`[ERROR] ${message}`, error);
    }
    // Em produção, você pode integrar com Sentry, LogRocket, etc:
    // Sentry.captureException(error);
  },

  warn: (message: string, data?: any) => {
    if (isDev) {
      console.warn(`[WARN] ${message}`, data);
    }
  },

  info: (message: string, data?: any) => {
    if (isDev) {
      console.log(`[INFO] ${message}`, data);
    }
  },

  debug: (message: string, data?: any) => {
    if (isDev) {
      console.log(`[DEBUG] ${message}`, data);
    }
  }
};
